import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import Lozenge, { type LozengeProps } from '@atlaskit/lozenge';

const messages = defineMessages({
	premium: {
		id: 'trial-components.lozenge.premium',
		defaultMessage: 'Premium',
		description: 'Label for Premium edition lozenge',
	},
});

export const PremiumLozenge = ({ testId }: Pick<LozengeProps, 'testId'>) => {
	return (
		<Lozenge appearance="discovery" testId={testId}>
			<FormattedMessage {...messages.premium} />
		</Lozenge>
	);
};
